<template>
    <div ref="click" class="datepicker" :class="{'input-hide': !showInput }">
        <div class="icon-input" @click="open_calendar">
            <Icon v-show="showInput" icon_name="calendar" />
        </div>
        <input v-show="showInput" ref='picker'
               v-bind="$attrs"
               class="input" v-on="$listeners"
        >
    </div>
</template>

<script>
import Icon from '@/components/ui/icons/icon.vue';
import flatpickr from 'flatpickr';
import {Russian} from 'flatpickr/dist/l10n/ru.js';
import English from 'flatpickr/dist/l10n/default';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);
export default {
  components: {
    Icon,
  },
  props: {
    offset: {
      type: Boolean,
    },
    inlined: {
      type: Boolean,
    },
    showInput: {
      type   : Boolean,
      default: true,
    },
    has_events: {
      type   : Boolean,
      default: false,
    },
    included: {
      type   : Boolean,
      default: false,
    },
    value: {
      type: String,
    },
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('calendar', [
      'calendar_dates',
    ]),
    ...mapGetters('events', ['events']),
    locale() {
      return this.$i18n.locale == 'ru' ? Russian : English;
    },
  },
  watch: {
    locale(nextLocale, prevLocale) {
      this.initPickerFor(nextLocale);
    },
  },
  async mounted() {
    if (this.has_events) {
      await this.get_courses_calendar();
    }
    this.initPickerFor(this.locale);
  },
  methods: {
    ...mapActions('calendar', ['check_date_for_use', 'get_courses_calendar']),
    open_calendar() {
      this.flatpickr.open();
    },
    clear_calendar() {
      this.flatpickr.clear();
    },
    get_ofset(el) {
      if (this.offset!==false) {
        const rect = el.getBoundingClientRect();
        return {
          left: rect.left + window.scrollX,
          top : rect.top + window.scrollY,
        };
      }
    },
    if_events(instance) {
      if (this.has_events) {
        for (let i=0; i<instance.days.children.length; i++) {
          let date = instance.days.children[i];
          let from = null;
          let to = null;
          if (this.calendar_dates.length!=0) {
            this.calendar_dates.forEach((item) => {
              from = new Date(item.date_assigned.split('.')[2], item.date_assigned.split('.')[1]-1, item.date_assigned.split('.')[0]);
              to = new Date(item.date_expired.split('.')[2], item.date_expired.split('.')[1]-1, item.date_expired.split('.')[0]);
              if (dayjs(date.dateObj).isAfter(dayjs(from)) && dayjs(date.dateObj).isBefore(dayjs(to))) {
                date.classList.add('has_event');
              }
              if (dayjs(date.dateObj).format('DD.MM.YYYY') == item.date_assigned) {
                date.classList.add('has_event', 'red-text');
              }
              if (dayjs(date.dateObj).format('DD.MM.YYYY') == item.date_expired) {
                date.classList.add('event_end');
              }
            });
          }
        }
      }
    },
    initPickerFor(locale) {
      this.flatpickr = flatpickr(this.$refs.picker, {
        'static'       : true,
        'locale'       : locale,
        'altInput'     : true,
        'altFormat'    : 'd.m.Y',
        'dateFormat'   : 'd.m.Y H:i',
        'disableMobile': 'true',
        'inline'       : this.inlined,
        'onReady'      : (selectedDates, dateStr, instance) => {
          this.if_events(instance);
        },
        'onMonthChange': (selectedDates, dateStr, instance) => {
          this.if_events(instance);
        },
        'onYearChange': (selectedDates, dateStr, instance) => {
          this.if_events(instance);
        },
        'onChange': (selectedDates, dateStr, instance) => {
          this.if_events(instance);
          // if (this.included) {
          //   instance.setDate(dateStr.slice(0, 10)+' 23:59', false);
          // }
          if (this.offset!==false) {
            const coord = {};
            coord.left = this.get_ofset(instance.selectedDateElem).left;
            coord.top = this.get_ofset(instance.selectedDateElem).top;
            this.$emit('coordinates', coord);

            this.$emit('input', new Date(selectedDates[0]).getTime(), coord);
          }
        },

      });
    },
  },

};
</script>
<style lang="less">
.has_event {
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 30px;
    left: 30px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #d5d5d9;
  }
}
.event_end {
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 30px;
    left: 30px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 2px solid red;
  }
}
.input-hide .flatpickr-input {
  display: none;
}
</style>

